import { createResource } from "@evergis/react-fetching";
import { LoginDc } from "@evergis/api";

import { redirectToSignIn } from "../utils/window";
import { api as evergisApi } from "../evergis/api";

const authParams: LoginDc | undefined =
  process.env.NODE_ENV === "production"
    ? void 0
    : evergisApi.isShared || evergisApi.isPresentation
    ? void 0
    : {
        username: process.env.LOGIN,
        password: process.env.PASSWORD,
      };

export class WorkspaceError extends Error {}

export const login = createResource<unknown, boolean, void, typeof evergisApi>(
  () => async api => {
    if (!api.isShared && !api.isPresentation) {
      try {
        await api.account.refreshToken({});
      } catch (error) {
        if (error.response.status === 404 && process.env.NODE_ENV === "production") {
          // eslint-disable-next-line max-depth
          try {
            await api.account.logout();
          } finally {
            redirectToSignIn();
          }
        }
      }
    }

    await api.init({
      authParams,
      fetchUser: !api.isShared && !api.isPresentation,
      connectWs: !api.isShared && !api.isPresentation,
      fetchSettings: true,
      initScheduler: !api.isShared && !api.isPresentation,
    });

    return { data: true };
  },
  { injected: evergisApi },
);
